/** User completed checkout before — Stripe Customer id retained on `users`. */
export function isReturningBillingCustomer(hasStripeCustomerId: boolean | undefined): boolean {
	return hasStripeCustomerId === true;
}

export function isOfferTrialEligibleForUser(
	offer: { trialEligible: boolean },
	isReturningCustomer: boolean,
): boolean {
	return offer.trialEligible && !isReturningCustomer;
}
